import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';
import { Sizes } from '../consts/Sizes.js';
import introData from '../data/Intro.js';
import { Fonts } from '../consts/Fonts.js';

export default class Intro extends AbstractScene {
    constructor() {
        super({ key: 'Intro' });
    }

    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setAlpha(0);
        this.tweens.add({
            targets: this.cameras.main,
            alpha: 1,
            duration: 500,
            ease: 'Power2',
        });
        // Afficher l’image
        if (this.sys.game.device.os.desktop) {
            this.add.image(0, 0, 'background').setOrigin(0);
        } else {
            // Create a gradient background for mobile
            const graphics = this.add.graphics();
            const width = this.sys.game.config.width;
            const height = this.sys.game.config.height;
            // Phaser does not have createGradient; use fillGradientStyle directly
            graphics.fillGradientStyle(0x0030ff, 0x8000ff, 0x8000ff, 0x0030ff, 1);
            graphics.fillRect(0, 0, width, height);
        }

        // Ajouter les flèches animées
        this.addAnimatedArrows();

        // Texte d'introduction
        console.log(introData[0].introText);
        const introTexte = this.add
            .text(200, this.height / 2 - 150, introData[0].introText, {
                fontFamily: Fonts.Text.h2,
                fontSize: Sizes.Text.h2,
                fill: Colors.Text.LightBlue,
                fontWeight: 'bold',
            })
            .setAlpha(0)
            .setOrigin(0, 0.5);

        // Titre
        const introTitre = this.add
            .text(190, this.height / 2, introData[0].titre, {
                fontFamily: Fonts.Text.h1,
                fontSize: Sizes.Text.h1,
                fill: Colors.Text.White,
                fontWeight: 'bold',
                letterSpacing: -4,
            })
            .setAlpha(0)
            .setOrigin(0, 0.5);

        // Logo Forecast
        const introLogoForecast = this.add
            .image(50, this.height / 2, 'logoForecast')
            .setOrigin(0.5, 0.5)
            .setScale(0.8)
            .setAlpha(0);

        // subtitle
        // const introSub = this.add
        //   .text(200, this.height / 2 + 120, introData[0].subtitle, {
        //     fontFamily: Fonts.Text.h1,
        //     fontSize: Sizes.Text.p,
        //     fill: Colors.Text.LightBlue,
        //     fontWeight: "bold",
        //   })
        //   .setAlpha(0)
        //   .setOrigin(0, 0.5);

        // Bouton "Commencer"
        this.btnCommencer = this.add.existing(
            new ButtonRounded(
                this,
                350,
                this.height / 2 + 350 + 100,
                330,
                76,
                introData[0].buttonLabel,
                Colors.Text.Blue,
                Colors.Elmt.Yellow,
                true,
                Colors.Elmt.Yellow,
                true,
                false,
                'fleche',
                ''
            )
        );
        this.btnCommencer.setAlpha(0).setDepth(99);

        this.tweens.add({
            targets: introTexte,
            alpha: 1,
            duration: 500,
            ease: 'Power2',
            delay: 500,
            onComplete: () => {
                this.tweens.add({
                    targets: [introLogoForecast, introTitre],
                    alpha: 1,
                    duration: 500,

                    ease: 'Power2',

                    onComplete: () => {
                        this.tweens.add({
                            targets: this.btnCommencer,
                            alpha: 1,

                            y: this.height / 2 + 220,
                            duration: 700,
                            ease: 'Power2',
                        });
                    },
                });
            },
        });

        // Bouton "Commencer" interaction
        this.btnCommencer.on('pointerdown', () => {
            this.scene.start('Menu');
        });

        // Shadow for the robot
        this.add.image(-800, 200, 'shadowRobot').setOrigin(0, 0).setScale(1.2);

        // Robot image
        const introRobot = this.add
            .image(this.width - 670, this.height / 2 + 100, 'introRobot')
            .setOrigin(0, 0.5)
            .setScale(0);

        // Animate robot coming from the right and back (scale up as it moves closer)
        introRobot.setPosition(this.width + 100, this.height + 100).setScale(0.5);
        this.tweens.add({
            delay: 500,
            targets: introRobot,
            x: this.width / 2 + 500,
            y: this.height / 2 + 100,
            scale: 0.5,
            duration: 700,
            ease: 'Power2',
            onComplete: () => {
                this.tweens.add({
                    targets: introRobot,
                    x: this.width / 2 + 400,
                    y: this.height / 2 + 100,
                    scale: 1,
                    duration: 1000,
                    ease: 'Back.In',
                });
            },
        });

        // Logo L'Oréal
        this.add
            .image(this.width - 100, this.height - 50, 'logoLoreal')
            .setOrigin(0.5, 0.5)
            .setScale(0.5, 0.5);
    }
}
